import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@snack-uikit/typography';
import { useCardContext } from '../../../../context';
import { TYPOGRAPHY_SIZE_MAP } from './constants';
import styles from './styles.module.css';
export function Dimension({ dimension, currentValue, oldValue, size: sizeProp }) {
    const { size: sizeContext } = useCardContext();
    const size = TYPOGRAPHY_SIZE_MAP[sizeProp || sizeContext];
    return (_jsxs("div", { className: styles.wrapper, children: [dimension && (_jsx(Typography, { purpose: 'title', family: 'sans', size: size, className: styles.dimension, children: dimension })), _jsxs("div", { className: styles.valueContainer, children: [_jsx(Typography, { purpose: 'title', family: 'sans', size: size, className: styles.currentValue, children: currentValue }), oldValue && _jsx(Typography.CrossedOutBodyS, { className: styles.oldValue, children: oldValue })] })] }));
}
